<template>
    <div>

       <div class="login-container tpg">

        <div class="alert alert-danger login-alert" v-if="error">
            <p>{{ error }}</p>
        </div>

        <div class="player-login-header">Login with your Email and Store Number</div>

            <div class="form-group">
                <input id="email"
                        v-on:keyup.enter="submit()"
                        type="email"
                        name="email"
                        v-model="email"
                        placeholder="Email Address"
                        class="login-form-text-field"
                        required
                        autofocus>
            </div>
            <div class="form-group">
                <input id="storeNumber"
                        v-on:keyup.enter="submit()"
                        type="text"
                        name="storeNumber"
                        placeholder="Store Number"
                        class="login-form-text-field"
                        v-model="store_number"
                        required>
            </div>
            <div>
            <button class="sign-in-button"
                   v-bind:class="{ 'sign-in-button-disabled': loading }"
                   @click="submit()"
                :disabled="loading">
              {{ submitButtonText }}
            </button>
            </div>
    </div>

    </div>
</template>

<script>
const Querystring = require('querystring');

export default {
  data() {
    return {
      email: '',
      store_number: '',
      error: '',
      loading: false,
    };
  },
  mounted() {
    this.loading = false;
    this.error = '';
  },
  methods: {

    submit() {
      this.loading = true;
      this.error = '';

      const credentials = {
        email: this.email,
        store_number: this.store_number,
      };

      this.login(credentials);
      // this.$emit('userLoggedIn');
    },
    login(creds) {
      this.$http.post('/login/player', Querystring.stringify(creds)).then((response) => {
        if (!response.data.error) {
          localStorage.setItem('si_access_token_expires_in', response.data.expires_in);
          localStorage.setItem('si_access_token', response.data.access_token);
          localStorage.setItem('si_refresh_token', response.data.refresh_token);

          // Emit to MainLayout to check AUTH
          // Include credentials
          this.$emit('userLoggedIn', creds);

          this.loading = false;
        } else {
          // Log errors for output
          this.error = 'Invalid email or store number.  Please try again';
          this.loading = false;
        }
      })
        .catch(() => {
          this.error = 'Invalid email or store number.  Please try again';
          this.loading = false;

          // alert("Invalid email or player id/store number combination.  Please try again");
        });
    },
  },
  computed: {
    submitButtonText() {
      if (this.loading) {
        return 'Checking login ....';
      }
      return 'Sign In';
    },
  },

};

</script>

<style>
.login-alert {
  position:relative;
  width:100%;
  top:-65px;
}
.orRow {
  text-align:center;
  padding-bottom:20px;
}
.login-form-text-field  {
  padding-left: 10px;
}
.login-container.tpg input[type="email"], .login-container.tpg input[type="text"] {
  border:1px solid #ccc;
  background:#fff;
  color:#666;
}
.player-login-header {
  width:300px;
  margin:0 auto;
  text-align:center;
  color:#666;
  font-size:20px;
  clear:both;
  padding-bottom:30px;
}
::-webkit-input-placeholder {
  color: #666;
}
</style>
